// extracted by mini-css-extract-plugin
module.exports = {"recommend":"recommend--31NX1","recommend_banner_weekhot":"recommend_banner_weekhot--10u6H","loading":"loading--HJc5N"};